import { render, staticRenderFns } from "./Products.html?vue&type=template&id=59e13c4a&external"
import script from "./Products.js?vue&type=script&lang=js&external"
export * from "./Products.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports